import {wasClicked} from '../../script';

const initialiseApplicationNavigation = () => {
  applyApplicationNavigationEvents();
};

const hideApplicationNavigationButton = () => {
  document.getElementsByClassName('section-navigation')[0].classList.add('hidden');
};

const revealApplicationNavigationButton = () => {
  document.getElementsByClassName('section-navigation')[0].classList.remove('hidden');
};

const hideApplicationNavigationText = () => {
  document.getElementsByClassName('section-navigation')[0].querySelector('h2').classList.add('hidden');
};

const revealApplicationNavigationText = () => {
  document.getElementsByClassName('section-navigation')[0].querySelector('h2').classList.remove('hidden');
};

const applyApplicationNavigationEvents = () => {
  document.getElementById('js:quick-go-back').addEventListener(
    'click',
    () => {
      fullpage_api.moveTo(4, 1);
    },
    true,
  );
  document.getElementById('js:ready-to-be').addEventListener(
    'click',
    () => {
      wasClicked(true);
      fullpage_api.moveTo(5);
      wasClicked(false);
    },
    true,
  );
  document.getElementById('js:navigation--desktop-cta').addEventListener(
    'click',
    () => {
      wasClicked(true);
      fullpage_api.moveTo(5);
      wasClicked(false);
    },
    true,
  );
  document.getElementById('js:navigation--mobile-cta').addEventListener(
    'click',
    () => {
      wasClicked(true);
      fullpage_api.moveTo(5);
      wasClicked(false);
    },
    true,
  );
  document.getElementsByClassName('section-navigation__button')[0].addEventListener(
    'click',
    () => {
      fullpage_api.moveSectionDown();
    },
    true,
  );
};

exports.initialiseApplicationNavigation = initialiseApplicationNavigation;
exports.hideApplicationNavigationButton = hideApplicationNavigationButton;
exports.revealApplicationNavigationButton = revealApplicationNavigationButton;
exports.hideApplicationNavigationText = hideApplicationNavigationText;
exports.revealApplicationNavigationText = revealApplicationNavigationText;
